export const AUTH_TOKEN = 'iq2-customer-token'